import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ModuleAccessService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiUrl + '/billing/';

  private modulesSubject = new BehaviorSubject<{ [key: string]: boolean }>({});
  modules$ = this.modulesSubject.asObservable();

  private hasActivePlan = false;
  private loaded = false;

  get modules(): { [key: string]: boolean } {
    return this.modulesSubject.value;
  }

  get isLoaded(): boolean {
    return this.loaded;
  }

  loadModules(): void {
    this.http.post<any>(`${this.baseUrl}account/allowed-modules/`, {}).subscribe({
      next: (res) => {
        if (res?.success) {
          this.hasActivePlan = res.has_active_plan || false;
          this.modulesSubject.next(res.modules || {});
        }
        this.loaded = true;
      },
      error: () => {
        this.loaded = true;
      },
    });
  }

  hasModule(key: string): boolean {
    if (!this.hasActivePlan) return false;
    return !!this.modules[key];
  }

  get canAccessRegistration(): boolean { return this.hasModule('registration'); }
  get canAccessPaper(): boolean { return this.hasModule('paper'); }
  get canAccessBadge(): boolean { return this.hasModule('badge'); }
  get canAccessCampaign(): boolean { return this.hasModule('campaign'); }
  get canAccessWebsite(): boolean { return this.hasModule('website'); }
  get canAccessProgram(): boolean { return this.hasModule('program'); }
  get canAccessCertificate(): boolean { return this.hasModule('certificate'); }
  get canAccessAbstract(): boolean { return this.hasModule('abstract'); }
  get canAccessPaymentGateway(): boolean { return this.hasModule('payment_gateway'); }
  get canAccessReports(): boolean { return this.hasModule('reports'); }
}
